import React from 'react';
import QRCode from 'react-qr-code';
import styled from "styled-components"

const QRCodeWrapper = styled("div")`
display: flex;
    justify-content: center;
    flex-direction:column;

`
const StyledMessage = styled("h4")`
text-align: center;
color: ${props => props.color};
background: transparent;
padding: 10px;
width: 296px;
padding: 5px 10px 10px;
border-radius: 10px;
margin-bottom:10px;
font-size: 21px;
font-family: 'Poppins', sans-serif;
`
const StyledThankyouMessage = styled("h4")`
text-align: center;
color: ${props => props.color};
background: transparent;
padding: 10px;
width: 296px;
padding: 10px 10px 10px;
border-radius: 10px;
margin-bottom:10px;
font-style:italic;
font-family: 'Poppins', sans-serif;
`
const QRCodeContainer = styled("div")`
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;

`
const StyledName = styled("p")`
font-size: 20px;
margin: 12px 0 2px;
text-transform: capitalize;
font-weight: 500;
color: #29562d;
font-style: italic;
font-family: 'Poppins', sans-serif;

`

const ShowQRCode = (props) => {
    const { qrText, isRedeemed, root, firstName, lastName } = props;
    const importAll = (r) => {
        let images = {};
        r.keys().map((item, index) => {
            images[item.replace("./", "")] = r(item);
        });
        return images;
    };

    const images = importAll(
        require.context("../../../images", false, /\.(png|jpe?g|svg)$/)
    );
    const fullName = `${firstName ? firstName.trim() : ""} ${lastName ? lastName.trim() : ""}`
    return (<>
        <QRCodeWrapper>
            <QRCodeContainer>
                <StyledMessage color="black">{root?.eventTym ? root.eventTym : "Thank You"}</StyledMessage>
                <QRCode value={qrText} bgColor="#e9ecef" />
                {fullName && fullName.trim() != "" && <StyledName>{fullName}</StyledName>}
                <StyledThankyouMessage style={{ fontSize: isRedeemed ? '30px' : "initial" }} color={isRedeemed ? "red" : "black"} >{isRedeemed ? "Sorry, Already Redeemed!" : "Please take this QR Code to nearest Distributor"}</StyledThankyouMessage>
            </QRCodeContainer>
        </QRCodeWrapper>
    </>)

}

export default ShowQRCode;